import { ClassValue } from 'clsx';
import { useTranslation } from 'react-i18next';

import { cn, formatBalance } from '@/app/shared/utils/common';
import { BalanceHistoryRow } from '@/app/store/slices/balance/balanceTypes';

export interface BalanceHistoryListItemProps extends BalanceHistoryRow {
  classNameRow: ClassValue;
  classNameFirstColumn: ClassValue;
  classNameSecondColumn: ClassValue;
  classNameThirdColumn: ClassValue;
  classNameFourthColumn: ClassValue;
}

export function BalanceHistoryListItem({
  id,
  balanceType,
  amount,
  description,
  // externalId,
  // metadata,
  source,
  createdAt,
  classNameRow,
  classNameFirstColumn,
  classNameSecondColumn,
  classNameThirdColumn,
  classNameFourthColumn,
}: BalanceHistoryListItemProps) {
  const { t } = useTranslation();

  const renderBalance = () => {
    return (
      <tr key={id} className={cn(classNameRow, 'text-background')}>
        <td className={cn(classNameFirstColumn)}>{description}</td>
        <td className={cn(classNameSecondColumn)}>{t(`balance.history.${source}`)}</td>
        <td className={cn(classNameThirdColumn)}>{formatBalance(balanceType, amount)}</td>
        <td className={cn(classNameFourthColumn)}>
          {new Date(createdAt).toLocaleDateString('ru-RU', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </td>
      </tr>
    );
  };

  return renderBalance();
}
